// keep up to date with Libraries/Core/Services/FeatureService.cs
export const EMPTY_FEATURE_FLAGS = {
    AI_AUTHORIZATION_PROOFS: false,
    ALL_CATEGORIES_PARAMETRIC_SEARCH: false,
    API_FEATURE_INVENTORY_AGENT: true,
    API_TRIAL_EXTENSION_REQUEST: false,
    BOM_EXPORT_LAMBDA: false,
    BOM_V2: false,
    CARBON_FOOTPRINT_API: false,
    CARBON_FOOTPRINT_REQUEST: false,
    CARBON_FOOTPRINT_WIDGET: false,
    CATEGORY_FULLTEXT_SEARCH: false,
    CN_FILEFEED_RESULTS: false,
    DATA_DOME_BOT_HEADERS: false,
    FAQ_STATIC_SITE: false,
    GLOBAL_INVENTORY: false,
    LEAD_TIME_REPORTING_PUBLIC: false,
    MAPPING_LAST_SEEN: false,
    MANUFACTURER_CATEGORIES: false,
    NEWSROOM: false,
    PART_CHART_FAILED_QUERY_LOGGING: false,
    PART_MODELS_PAGE: false,
    PRODUCT_SPOTLIGHTS: false,
    RESULTS_BY_PART_DEFAULT: false,
    SEARCH_PROGRESSIVE_DELIVERY: false,
    SFTP_SELF_SERVICE: false,
    SHOW_SPECIAL_PRICING: false,
    SMART_SEARCH_INDEX_ENABLED: true,
    SLUICEBOX_INTEGRATION: false,
    SMART_SEARCH_QUERY_PARSING: false,
    SMART_SEARCH: false,
    SNAP_MAGIC_MODELS: false,
    TAILWIND_COMPONENTS_PAGE: false,
    TOTP_REGISTRATION: false,
};

export type FeatureFlags = typeof EMPTY_FEATURE_FLAGS;
